module.exports = __webpack_public_path__ + "static/media/56.2e7cffc0.jpg";